import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import { UploadFile as IUploadFile } from 'antd/lib/upload/interface';
import React, { useEffect, useState } from 'react';
import RemoveButton from '../../Buttons/RemoveButton';

interface UploadFieldProps {
  multiple?: boolean;
  showUploadList?: boolean;
  label?: string;
  types?: string;
}

const UploadField: React.FC<UploadFieldProps | any> = ({
  showUploadList = false,
  multiple = false,
  label = 'Clicca o trascina un file',
  types = '.pdf',
  ...props
}) => {
  useEffect(() => {
    document.body?.addEventListener('dragover', (ev) => {
      ev.preventDefault();
    });
    document.body?.addEventListener('drop', (ev) => {
      ev.preventDefault();
    });

    return () => {
      document.body?.removeEventListener('dragover', (ev) => {
        ev.preventDefault();
      });
      document.body?.removeEventListener('drop', (ev) => {
        ev.preventDefault();
      });
    };
  }, []);

  const [fileList, setFileList] = useState<IUploadFile<any>[]>(props.value ? [props.value] : []);
  const [uploading, setUploading] = useState(false);

  const UploadPros: UploadProps = {
    name: 'fileToUpload',
    multiple,
    accept: types,
    showUploadList: false,

    beforeUpload: (file) => {
      const files = multiple ? [...fileList, file] : [file];
      setFileList(files);
      props.onChange(files);
      return false;
    },
    // listType: "picture-card",
    //    iconRender: () => "picture",
    onChange(info) {
      //      const { status } = info.file;

      // if (status === "removed")

      //   if (multiple) {

      //     setFileList(files => files.filter((file) => file.uid !== info.file.uid))
      //   }
      setFileList(info.fileList);
      props.onChange(info.fileList);
    },
    onRemove(file) {
      setUploading(false);
    },

    // showUploadList: {
    //   showDownloadIcon: true,
    //   showPreviewIcon: true,
    //   showRemoveIcon: true
    // },

    // disabled: multiple ? false : fileList.length > 0
  };

  const removeFile = (index) => {
    let newFileList = fileList;
    if (multiple) {
      newFileList = newFileList.filter((arr, i) => i !== index);
    } else {
      newFileList = [];
    }

    setFileList(newFileList);
    props.onChange(newFileList);
  };
  return (
    <>
      {(multiple || fileList.length === 0) && (
        <Upload.Dragger {...UploadPros} fileList={fileList}>
          <Button icon={<UploadOutlined />}>Clicca o trascina un file</Button>
        </Upload.Dragger>
      )}
      {fileList.length > 0 &&
        fileList.map((file, index) => (
          <div className="UploadFiles">
            <UploadFile file={file} onClick={() => removeFile(index)} />
          </div>
        ))}
    </>
  );
};

export default UploadField;

interface IFileUploaded<T> extends IUploadFile<T> {
  pdf_url?: string;
  file_name?: string;
  media_id?: number;
}
const UploadFile = ({ file, onClick }: { file: IFileUploaded<any>; onClick: any }) => (
  <div className="UploadFile">
    <div>
      {file?.fileName || file?.file_name || file?.name || 'File caricato'}{' '}
    </div>
    <div>
      <RemoveButton onClick={onClick} />
    </div>
  </div>
);

export const FileUploaded = React.memo(UploadFile);
